export const version = "1.0.2-daily-20260520-0";
export const channel = "daily";
export const gitcommit = "28e4ecaf4";
